/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';

export default (salesTypeId = null) => (dispatch) => {
    return cecSdk
        .connectionSalesTypes(salesTypeId)
        .remove()
        .then(() => {
            dispatch({ type: actions.DELETE_CONNECTION_SALES_TYPES_SUCCESS, payload: { salesTypeId } });
        });
};
